export default __webpack_public_path__ + "static/media/image-2.6a9bd2f0.png";